(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7ff4"];
parcelRequire.register("6mV7H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a311b9b4db22013$export$2e2bcd8739ae039; });

var $bwojW = parcelRequire("bwojW");
var $4v67M = parcelRequire("4v67M");
const $4a311b9b4db22013$var$SimpleHeader = ()=>{
    const els = document.querySelectorAll(".simple-header");
    if (els.length) els.forEach((el)=>{
        (0, $4v67M.scroll)((0, $bwojW.animate)(el, {
            opacity: [
                0,
                1,
                1,
                0
            ],
            y: [
                0,
                0,
                0,
                100
            ]
        }), {
            target: el,
            offset: [
                "start end",
                "end end",
                "start start",
                "end start"
            ]
        });
    });
};
var $4a311b9b4db22013$export$2e2bcd8739ae039 = $4a311b9b4db22013$var$SimpleHeader;

});
parcelRequire.register("4v67M", function(module, exports) {

$parcel$export(module.exports, "scroll", function () { return $346ecee0f38d29ed$export$209876d7b1ac8f3; });

var $56cRO = parcelRequire("56cRO");

var $4c3Si = parcelRequire("4c3Si");

var $lLwq1 = parcelRequire("lLwq1");

var $egBxz = parcelRequire("egBxz");
const $346ecee0f38d29ed$var$scrollListeners = new WeakMap();
const $346ecee0f38d29ed$var$resizeListeners = new WeakMap();
const $346ecee0f38d29ed$var$onScrollHandlers = new WeakMap();
const $346ecee0f38d29ed$var$getEventTarget = (element)=>element === document.documentElement ? window : element;
function $346ecee0f38d29ed$export$209876d7b1ac8f3(onScroll, _a = {}) {
    var { container: container = document.documentElement  } = _a, options = (0, $56cRO.__rest)(_a, [
        "container"
    ]);
    let containerHandlers = $346ecee0f38d29ed$var$onScrollHandlers.get(container);
    /**
     * Get the onScroll handlers for this container.
     * If one isn't found, create a new one.
     */ if (!containerHandlers) {
        containerHandlers = new Set();
        $346ecee0f38d29ed$var$onScrollHandlers.set(container, containerHandlers);
    }
    /**
     * Create a new onScroll handler for the provided callback.
     */ const info = (0, $lLwq1.createScrollInfo)();
    const containerHandler = (0, $egBxz.createOnScrollHandler)(container, onScroll, info, options);
    containerHandlers.add(containerHandler);
    /**
     * Check if there's a scroll event listener for this container.
     * If not, create one.
     */ if (!$346ecee0f38d29ed$var$scrollListeners.has(container)) {
        const listener = ()=>{
            const time = performance.now();
            for (const handler of containerHandlers)handler.measure();
            for (const handler of containerHandlers)handler.update(time);
            for (const handler of containerHandlers)handler.notify();
        };
        $346ecee0f38d29ed$var$scrollListeners.set(container, listener);
        const target = $346ecee0f38d29ed$var$getEventTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $346ecee0f38d29ed$var$resizeListeners.set(container, (0, $4c3Si.resize)(container, listener));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const listener = $346ecee0f38d29ed$var$scrollListeners.get(container);
    const onLoadProcesss = requestAnimationFrame(listener);
    return ()=>{
        var _a;
        if (typeof onScroll !== "function") onScroll.stop();
        cancelAnimationFrame(onLoadProcesss);
        /**
         * Check if we even have any handlers for this container.
         */ const containerHandlers = $346ecee0f38d29ed$var$onScrollHandlers.get(container);
        if (!containerHandlers) return;
        containerHandlers.delete(containerHandler);
        if (containerHandlers.size) return;
        /**
         * If no more handlers, remove the scroll listener too.
         */ const listener = $346ecee0f38d29ed$var$scrollListeners.get(container);
        $346ecee0f38d29ed$var$scrollListeners.delete(container);
        if (listener) {
            $346ecee0f38d29ed$var$getEventTarget(container).removeEventListener("scroll", listener);
            (_a = $346ecee0f38d29ed$var$resizeListeners.get(container)) === null || _a === void 0 || _a();
            window.removeEventListener("resize", listener);
        }
    };
}

});
parcelRequire.register("4c3Si", function(module, exports) {

$parcel$export(module.exports, "resize", function () { return $30db49e1c9f9c1d1$export$4380c87abf28fdf; });

var $wMU7k = parcelRequire("wMU7k");

var $4yoDU = parcelRequire("4yoDU");

var $9Gaz0 = parcelRequire("9Gaz0");
function $30db49e1c9f9c1d1$export$4380c87abf28fdf(a, b) {
    return (0, $9Gaz0.isFunction)(a) ? (0, $4yoDU.resizeWindow)(a) : (0, $wMU7k.resizeElement)(a, b);
}

});
parcelRequire.register("wMU7k", function(module, exports) {

$parcel$export(module.exports, "resizeElement", function () { return $0628ec9cd45e4afb$export$81a0e12ec749d682; });

var $kqd0U = parcelRequire("kqd0U");
const $0628ec9cd45e4afb$var$resizeHandlers = new WeakMap();
let $0628ec9cd45e4afb$var$observer;
function $0628ec9cd45e4afb$var$getElementSize(target, borderBoxSize) {
    if (borderBoxSize) {
        const { inlineSize: inlineSize , blockSize: blockSize  } = borderBoxSize[0];
        return {
            width: inlineSize,
            height: blockSize
        };
    } else if (target instanceof SVGElement && "getBBox" in target) return target.getBBox();
    else return {
        width: target.offsetWidth,
        height: target.offsetHeight
    };
}
function $0628ec9cd45e4afb$var$notifyTarget({ target: target , contentRect: contentRect , borderBoxSize: borderBoxSize  }) {
    var _a;
    (_a = $0628ec9cd45e4afb$var$resizeHandlers.get(target)) === null || _a === void 0 || _a.forEach((handler)=>{
        handler({
            target: target,
            contentSize: contentRect,
            get size () {
                return $0628ec9cd45e4afb$var$getElementSize(target, borderBoxSize);
            }
        });
    });
}
function $0628ec9cd45e4afb$var$notifyAll(entries) {
    entries.forEach($0628ec9cd45e4afb$var$notifyTarget);
}
function $0628ec9cd45e4afb$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $0628ec9cd45e4afb$var$observer = new ResizeObserver($0628ec9cd45e4afb$var$notifyAll);
}
function $0628ec9cd45e4afb$export$81a0e12ec749d682(target, handler) {
    if (!$0628ec9cd45e4afb$var$observer) $0628ec9cd45e4afb$var$createResizeObserver();
    const elements = (0, $kqd0U.resolveElements)(target);
    elements.forEach((element)=>{
        let elementHandlers = $0628ec9cd45e4afb$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $0628ec9cd45e4afb$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $0628ec9cd45e4afb$var$observer === null || $0628ec9cd45e4afb$var$observer === void 0 || $0628ec9cd45e4afb$var$observer.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $0628ec9cd45e4afb$var$resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 || elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) $0628ec9cd45e4afb$var$observer === null || $0628ec9cd45e4afb$var$observer === void 0 || $0628ec9cd45e4afb$var$observer.unobserve(element);
        });
    };
}

});

parcelRequire.register("4yoDU", function(module, exports) {

$parcel$export(module.exports, "resizeWindow", function () { return $350d73e678134043$export$7fc81011b72cd94d; });
const $350d73e678134043$var$windowCallbacks = new Set();
let $350d73e678134043$var$windowResizeHandler;
function $350d73e678134043$var$createWindowResizeHandler() {
    $350d73e678134043$var$windowResizeHandler = ()=>{
        const size = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        const info = {
            target: window,
            size: size,
            contentSize: size
        };
        $350d73e678134043$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $350d73e678134043$var$windowResizeHandler);
}
function $350d73e678134043$export$7fc81011b72cd94d(callback) {
    $350d73e678134043$var$windowCallbacks.add(callback);
    if (!$350d73e678134043$var$windowResizeHandler) $350d73e678134043$var$createWindowResizeHandler();
    return ()=>{
        $350d73e678134043$var$windowCallbacks.delete(callback);
        if (!$350d73e678134043$var$windowCallbacks.size && $350d73e678134043$var$windowResizeHandler) $350d73e678134043$var$windowResizeHandler = undefined;
    };
}

});


parcelRequire.register("lLwq1", function(module, exports) {

$parcel$export(module.exports, "createScrollInfo", function () { return $fd87226d90237c9f$export$38ba9ec5092d2d70; });
$parcel$export(module.exports, "updateScrollInfo", function () { return $fd87226d90237c9f$export$55f50a00c84f0ed3; });

var $geNSS = parcelRequire("geNSS");
var $aXze8 = parcelRequire("aXze8");
/**
 * A time in milliseconds, beyond which we consider the scroll velocity to be 0.
 */ const $fd87226d90237c9f$var$maxElapsed = 50;
const $fd87226d90237c9f$var$createAxisInfo = ()=>({
        current: 0,
        offset: [],
        progress: 0,
        scrollLength: 0,
        targetOffset: 0,
        targetLength: 0,
        containerLength: 0,
        velocity: 0
    });
const $fd87226d90237c9f$export$38ba9ec5092d2d70 = ()=>({
        time: 0,
        x: $fd87226d90237c9f$var$createAxisInfo(),
        y: $fd87226d90237c9f$var$createAxisInfo()
    });
const $fd87226d90237c9f$var$keys = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
function $fd87226d90237c9f$var$updateAxisInfo(element, axisName, info, time) {
    const axis = info[axisName];
    const { length: length , position: position  } = $fd87226d90237c9f$var$keys[axisName];
    const prev = axis.current;
    const prevTime = info.time;
    axis.current = element["scroll" + position];
    axis.scrollLength = element["scroll" + length] - element["client" + length];
    axis.offset.length = 0;
    axis.offset[0] = 0;
    axis.offset[1] = axis.scrollLength;
    axis.progress = (0, $geNSS.progress)(0, axis.scrollLength, axis.current);
    const elapsed = time - prevTime;
    axis.velocity = elapsed > $fd87226d90237c9f$var$maxElapsed ? 0 : (0, $aXze8.velocityPerSecond)(axis.current - prev, elapsed);
}
function $fd87226d90237c9f$export$55f50a00c84f0ed3(element, info, time) {
    $fd87226d90237c9f$var$updateAxisInfo(element, "x", info, time);
    $fd87226d90237c9f$var$updateAxisInfo(element, "y", info, time);
    info.time = time;
}

});
parcelRequire.register("aXze8", function(module, exports) {

$parcel$export(module.exports, "velocityPerSecond", function () { return $7faabd65d0b80610$export$eab0632f7ad4f9d7; });
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ function $7faabd65d0b80610$export$eab0632f7ad4f9d7(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

});


parcelRequire.register("egBxz", function(module, exports) {

$parcel$export(module.exports, "createOnScrollHandler", function () { return $a62fae15e1b6f97a$export$9dd72aeec3645b49; });

var $9Gaz0 = parcelRequire("9Gaz0");
var $k5N1q = parcelRequire("k5N1q");

var $lLwq1 = parcelRequire("lLwq1");

var $lwfie = parcelRequire("lwfie");
function $a62fae15e1b6f97a$var$measure(container, target = container, info) {
    /**
     * Find inset of target within scrollable container
     */ info.x.targetOffset = 0;
    info.y.targetOffset = 0;
    if (target !== container) {
        let node = target;
        while(node && node != container){
            info.x.targetOffset += node.offsetLeft;
            info.y.targetOffset += node.offsetTop;
            node = node.offsetParent;
        }
    }
    info.x.targetLength = target === container ? target.scrollWidth : target.clientWidth;
    info.y.targetLength = target === container ? target.scrollHeight : target.clientHeight;
    info.x.containerLength = container.clientWidth;
    info.y.containerLength = container.clientHeight;
}
function $a62fae15e1b6f97a$export$9dd72aeec3645b49(element, onScroll, info, options = {}) {
    const axis = options.axis || "y";
    return {
        measure: ()=>$a62fae15e1b6f97a$var$measure(element, options.target, info),
        update: (time)=>{
            (0, $lLwq1.updateScrollInfo)(element, info, time);
            if (options.offset || options.target) (0, $lwfie.resolveOffsets)(element, info, options);
        },
        notify: (0, $9Gaz0.isFunction)(onScroll) ? ()=>onScroll(info) : $a62fae15e1b6f97a$var$scrubAnimation(onScroll, info[axis])
    };
}
function $a62fae15e1b6f97a$var$scrubAnimation(controls, axisInfo) {
    controls.pause();
    controls.forEachNative((animation, { easing: easing  })=>{
        var _a, _b;
        if (animation.updateDuration) {
            if (!easing) animation.easing = (0, $k5N1q.noopReturn);
            animation.updateDuration(1);
        } else {
            const timingOptions = {
                duration: 1000
            };
            if (!easing) timingOptions.easing = "linear";
            (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.updateTiming) === null || _b === void 0 || _b.call(_a, timingOptions);
        }
    });
    return ()=>{
        controls.currentTime = axisInfo.progress;
    };
}

});
parcelRequire.register("lwfie", function(module, exports) {

$parcel$export(module.exports, "resolveOffsets", function () { return $faa8730a27011c83$export$44b097f22602edfc; });

var $5sHEg = parcelRequire("5sHEg");
var $2MHqZ = parcelRequire("2MHqZ");

var $b4lRf = parcelRequire("b4lRf");

var $3QKBE = parcelRequire("3QKBE");

var $aEShd = parcelRequire("aEShd");
const $faa8730a27011c83$var$point = {
    x: 0,
    y: 0
};
function $faa8730a27011c83$export$44b097f22602edfc(container, info, options) {
    let { offset: offsetDefinition = (0, $3QKBE.ScrollOffset).All  } = options;
    const { target: target = container , axis: axis = "y"  } = options;
    const lengthLabel = axis === "y" ? "height" : "width";
    const inset = target !== container ? (0, $b4lRf.calcInset)(target, container) : $faa8730a27011c83$var$point;
    /**
     * Measure the target and container. If they're the same thing then we
     * use the container's scrollWidth/Height as the target, from there
     * all other calculations can remain the same.
     */ const targetSize = target === container ? {
        width: container.scrollWidth,
        height: container.scrollHeight
    } : {
        width: target.clientWidth,
        height: target.clientHeight
    };
    const containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
    };
    /**
     * Reset the length of the resolved offset array rather than creating a new one.
     * TODO: More reusable data structures for targetSize/containerSize would also be good.
     */ info[axis].offset.length = 0;
    /**
     * Populate the offset array by resolving the user's offset definition into
     * a list of pixel scroll offets.
     */ let hasChanged = !info[axis].interpolate;
    const numOffsets = offsetDefinition.length;
    for(let i = 0; i < numOffsets; i++){
        const offset = (0, $aEShd.resolveOffset)(offsetDefinition[i], containerSize[lengthLabel], targetSize[lengthLabel], inset[axis]);
        if (!hasChanged && offset !== info[axis].interpolatorOffsets[i]) hasChanged = true;
        info[axis].offset[i] = offset;
    }
    /**
     * If the pixel scroll offsets have changed, create a new interpolator function
     * to map scroll value into a progress.
     */ if (hasChanged) {
        info[axis].interpolate = (0, $2MHqZ.interpolate)((0, $5sHEg.defaultOffset)(numOffsets), info[axis].offset);
        info[axis].interpolatorOffsets = [
            ...info[axis].offset
        ];
    }
    info[axis].progress = info[axis].interpolate(info[axis].current);
}

});
parcelRequire.register("b4lRf", function(module, exports) {

$parcel$export(module.exports, "calcInset", function () { return $80f105ed60086158$export$6858938830d6a6db; });
function $80f105ed60086158$export$6858938830d6a6db(element, container) {
    let inset = {
        x: 0,
        y: 0
    };
    let current = element;
    while(current && current !== container){
        if (current instanceof HTMLElement) {
            inset.x += current.offsetLeft;
            inset.y += current.offsetTop;
            current = current.offsetParent;
        } else if (current instanceof SVGGraphicsElement && "getBBox" in current) {
            const { top: top , left: left  } = current.getBBox();
            inset.x += left;
            inset.y += top;
            /**
             * Assign the next parent element as the <svg /> tag.
             */ while(current && current.tagName !== "svg")current = current.parentNode;
        }
    }
    return inset;
}

});

parcelRequire.register("3QKBE", function(module, exports) {

$parcel$export(module.exports, "ScrollOffset", function () { return $2cda6173c1becd14$export$e59548524dcf6540; });
const $2cda6173c1becd14$export$e59548524dcf6540 = {
    Enter: [
        [
            0,
            1
        ],
        [
            1,
            1
        ]
    ],
    Exit: [
        [
            0,
            0
        ],
        [
            1,
            0
        ]
    ],
    Any: [
        [
            1,
            0
        ],
        [
            0,
            1
        ]
    ],
    All: [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ]
};

});

parcelRequire.register("aEShd", function(module, exports) {

$parcel$export(module.exports, "resolveOffset", function () { return $7c27be07cfc2dece$export$1d98ea10734f1dc1; });

var $50VeR = parcelRequire("50VeR");
var $eup42 = parcelRequire("eup42");

var $bMDep = parcelRequire("bMDep");
const $7c27be07cfc2dece$var$defaultOffset = [
    0,
    0
];
function $7c27be07cfc2dece$export$1d98ea10734f1dc1(offset, containerLength, targetLength, targetInset) {
    let offsetDefinition = Array.isArray(offset) ? offset : $7c27be07cfc2dece$var$defaultOffset;
    let targetPoint = 0;
    let containerPoint = 0;
    if ((0, $50VeR.isNumber)(offset)) /**
         * If we're provided offset: [0, 0.5, 1] then each number x should become
         * [x, x], so we default to the behaviour of mapping 0 => 0 of both target
         * and container etc.
         */ offsetDefinition = [
        offset,
        offset
    ];
    else if ((0, $eup42.isString)(offset)) {
        offset = offset.trim();
        if (offset.includes(" ")) offsetDefinition = offset.split(" ");
        else /**
             * If we're provided a definition like "100px" then we want to apply
             * that only to the top of the target point, leaving the container at 0.
             * Whereas a named offset like "end" should be applied to both.
             */ offsetDefinition = [
            offset,
            (0, $bMDep.namedEdges)[offset] ? offset : `0`
        ];
    }
    targetPoint = (0, $bMDep.resolveEdge)(offsetDefinition[0], targetLength, targetInset);
    containerPoint = (0, $bMDep.resolveEdge)(offsetDefinition[1], containerLength);
    return targetPoint - containerPoint;
}

});
parcelRequire.register("bMDep", function(module, exports) {

$parcel$export(module.exports, "namedEdges", function () { return $89429bf7e2f981d4$export$5329d185756d2568; });
$parcel$export(module.exports, "resolveEdge", function () { return $89429bf7e2f981d4$export$1a4fccdf0f25754b; });

var $50VeR = parcelRequire("50VeR");
var $eup42 = parcelRequire("eup42");
const $89429bf7e2f981d4$export$5329d185756d2568 = {
    start: 0,
    center: 0.5,
    end: 1
};
function $89429bf7e2f981d4$export$1a4fccdf0f25754b(edge, length, inset = 0) {
    let delta = 0;
    /**
     * If we have this edge defined as a preset, replace the definition
     * with the numerical value.
     */ if ($89429bf7e2f981d4$export$5329d185756d2568[edge] !== undefined) edge = $89429bf7e2f981d4$export$5329d185756d2568[edge];
    /**
     * Handle unit values
     */ if ((0, $eup42.isString)(edge)) {
        const asNumber = parseFloat(edge);
        if (edge.endsWith("px")) delta = asNumber;
        else if (edge.endsWith("%")) edge = asNumber / 100;
        else if (edge.endsWith("vw")) delta = asNumber / 100 * document.documentElement.clientWidth;
        else if (edge.endsWith("vh")) delta = asNumber / 100 * document.documentElement.clientHeight;
        else edge = asNumber;
    }
    /**
     * If the edge is defined as a number, handle as a progress value.
     */ if ((0, $50VeR.isNumber)(edge)) delta = length * edge;
    return inset + delta;
}

});






})();
//# sourceMappingURL=simple-header.b57bb642.js.map
